import "./ProximosShowsSection.css";

const events = [
  {
    id: 1,
    date: "2026-09-10T12:00:00",
    time: "20h",
    description: "Brasil Papaya + Camerata Florianópolis",
    location: "Teatro Municipal de Pomerode / Centro Cultural de Pomerode – Rua Hermann Weege, 111, Centro, Pomerode/SC",
    ticketUrl: "https://www.sympla.com.br/evento/yakamoz-brasil-papaya-instrumental-camerata-florianopolis/3550081?algoliaID=56228ae49efa3d0de1109385a0dc746f"
  },
  {
    id: 2,
    date: "2026-09-11T12:00:00",
    time: "20h",
    description: "Brasil Papaya + Camerata Florianópolis",
    location: "Teatro Municipal de Itajaí – Rua Gregório Chaves, 111, Bairro Fazenda, Itajaí/SC",
    ticketUrl: "https://www.sympla.com.br/evento/yakamoz-brasil-papaya-instrumental-camerata-florianopolis/3550174?algoliaID=56228ae49efa3d0de1109385a0dc746f"
  }
];

const ProximosShowsSection = () => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  };

  return (
    <div className="proximos-shows">
      <div className="shows-section-show">
        <h2 className="shows-title">Próximos Shows</h2>

        {events.length === 0 ? (
          <div className="no-events">Nenhum show agendado no momento</div>
        ) : (
          events.map((event) => (
            <div key={event.id} className="shows-container-show">
              <div className="shows-content-show">

                <div className="show-item-show">
                  <div className="data-and-local">
                    <div className="show-text-show">
                      <div className="show-data">
                        {formatDate(event.date)} – {event.time}
                      </div>
                      <div className="show-place">{event.description}</div>
                    </div>
                  </div>
                </div>

                <div className="show-item-show">
                  <div className="show-address-show">
                    <img
                      className="icon"
                      src="location_on.svg"
                      alt="Localização"
                    />
                    <p className="local-show">{event.location}</p>
                  </div>
                </div>

                <div className="show-item-show">
                  <button
                    className="buy-ticket-btn"
                    onClick={() => window.open(event.ticketUrl, "_blank", "noopener,noreferrer")}
                  >
                    INGRESSOS
                  </button>
                </div>

              </div>
            </div>
          ))
        )}

      </div>
    </div>
  );
};

export default ProximosShowsSection;